import queryString from 'query-string';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useThrottleFn } from 'react-use';

import { authActions } from 'app-components/flux/auth';
import { isDemoMode, localPreferences, getClientConfig, getLogger } from 'app-components/utils/core';

import useAuthURL from 'components/Dialogs/AuthDialog/useAuthURL';
import LoadingView from 'components/LoadingView';

const logger = getLogger('containers/App/Login/index.js');

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authURL = useAuthURL();
  useThrottleFn(
    () => {
      const query = queryString.parse(window.location.search);
      if (isDemoMode() && query.code.includes('DEMO')) {
        // TODO: find better way to identify demo login
        dispatch(authActions.getOAuthToken(query.code));
        navigate('/', { replace: true });
      } else if (query.code && query.session_state) {
        // normal app mode (not inside iframe) - login link + special handling for cypress
        const remoteSessionState = atob(decodeURIComponent(query.session_state));
        let localSessionStates = [];
        try {
          localSessionStates = JSON.parse(localStorage.getItem('sessionStates') || '');
          localSessionStates = Array.isArray(localSessionStates) ? localSessionStates : [];
        } catch (e) {
          assert(false, e);
        }
        if (
          window === window.top &&
          (getClientConfig().environment === 'prod' ||
            (!window?.top?.Cypress && !localSessionStates.includes(remoteSessionState)))
        ) {
          logger.error('user session mismatch', localSessionStates, remoteSessionState);
          navigate('/logout', { replace: true }); // would be misleading if we keep existing user logged-in
        } else {
          localPreferences.setKeepLoggedIn(Boolean(query.remember_me));
          // check if we are iframe
          if (window !== window.top || window?.top?.Cypress) {
            window.parent?.postMessage(
              {
                type: 'auth',
                code: query.code,
                sessionState: remoteSessionState,
              },
              window.origin,
            ); // send message event to iframe parent
          } else {
            dispatch(authActions.getOAuthToken(query.code, { props: { sessionState: remoteSessionState } }));
            navigate('/', { replace: true }); // redirect if not inside iframe
          }
        }
      } else if (window === window.top) {
        // normal app mode (not inside iframe)
        navigate('/', { replace: true }); // redirect
      }
    },
    1000,
    [navigate, authURL],
  );

  return <LoadingView />;
}

export default Login;
